"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatUnits = void 0;
function formatUnits(value, decimals) {
  let display = value.toString();
  const negative = display.startsWith('-');
  if (negative) display = display.slice(1);
  display = display.padStart(decimals, '0');
  let [integer, fraction] = [display.slice(0, display.length - decimals), display.slice(display.length - decimals)];
  fraction = fraction.replace(/(0+)$/, '');
  return "".concat(negative ? '-' : '').concat(integer || '0').concat(fraction ? ".".concat(fraction) : '');
}
exports.formatUnits = formatUnits;
//# sourceMappingURL=formatUnits.js.map